import * as React from 'react';

import './shared-access-product-tile.scss';

type Props = {
  name: string,
  brand: string,
  imageUrl: string,
  price: string,
  itemUrl: string
};

const SharedAccessProductTile = (
  {
    name,
    brand,
    imageUrl,
    itemUrl,
    price
  }: Props
): JSX.Element => (
  <article className="shared-access-product-tile">
    <a
      href={itemUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="shared-access-product-tile__content"
    >
      <img
        src={imageUrl}
        alt={name}
        className="shared-access-product-tile__image"
      />
      <div
        title={brand}
        className="shared-access-product-tile__brand text-overflow-ellipsis"
      >
        {brand}
      </div>
      <div
        title={name}
        className="shared-access-product-tile__title text-overflow-ellipsis"
      >
        {name}
      </div>
      <div className="shared-access-product-tile__price">
        {price}
      </div>
    </a>
  </article>
);

export default SharedAccessProductTile;
